import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCursorClick: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCursorClick"><Path d="M11 2.5V4.5M17.1569 4.84326L15.5962 6.40392M6.40381 15.5962L4.84315 17.1569M4.5 11H2.5M6.40381 6.40381L4.84315 4.84315M14.5 21.5L10 10L21.5 14.5L17 17L14.5 21.5Z" stroke="currentColor" strokeWidth="1.04545" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCursorClick;
